<div class="row w-100 pt-3 text-center row-title">
    @if (!isEsim) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Activer ma carte SIM</div>
    }
    @if (isEsim) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Activer mon eSIM</div>
    }
</div>

<div class="w-100 pt-3 text-center">
    @if (!isEsim) {
        <div>Je souhaite activer ma carte SIM maintenant. Cette action désactivera votre ancienne carte SIM.</div>
    }
    @if (isEsim) {
        <div>
            Je souhaite activer mon eSIM maintenant.<br/>Cette action désactivera votre ancienne SIM.
            <br/><br/>
            Le QR code de votre eSIM sera disponible dans les 24h suivant l’activation, dans la rubrique Lignes > Infos
            et documents.
        </div>
    }
    <div class="w-100 pt-3 text-center cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>

